import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFeatureEnabled, useLoginUrl } from "@/hooks";
import { TooltipInfos } from "@/components";
import { Box } from "@gemini/core";
import { CheckFilledIcon, InfoCircleIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { useI18n } from "@/contexts/i18n";
import { IS_SERVER } from "@/constants";
export const LoginBox = () => {
    const loginUrl = useLoginUrl();
    const { t } = useI18n();
    const isAuthenticationEnabled = useFeatureEnabled("authentication");
    const handleLogin = () => {
        if (IS_SERVER)
            return;
        window.location.href = loginUrl;
    };
    if (!isAuthenticationEnabled)
        return null;
    return (_jsxs(Box, { display: "flex", flexDirection: "column", padding: "spacing.24", backgroundColor: "color.surface.light.default", borderRadius: "radius.16", marginBottom: "spacing.24", children: [_jsxs(Box, { display: "flex", alignItems: "center", typography: "typography.body.16.bold", marginBottom: "spacing.16", children: [t("contact.form.login_box.title"), _jsx(TooltipInfos, { content: t("contact.form.login_box.tooltip"), icon: _jsx(InfoCircleIcon, { size: "sizing.24" }) })] }), _jsxs(Box, { typography: "typography.body.14.regular", color: "color.content.light.default", children: [_jsxs(Box, { children: [_jsx(CheckFilledIcon, { marginRight: "spacing.12" }), t("contact.form.login_box.text_line1")] }), _jsxs(Box, { marginBottom: "spacing.16", children: [_jsx(CheckFilledIcon, { marginRight: "spacing.12" }), t("contact.form.login_box.text_line2")] }), _jsx(Button, { isFullWidth: true, variant: "secondary", onPress: handleLogin, children: t("contact.form.login_box.button_text") })] })] }));
};
